import { type Service } from "@modules/core/services/serviceType"
import { LocalStorageKeys } from "@modules/storage/localStorageKeys"
import { LocalStorageService } from "@modules/storage/services/localStorageService"
import { DEFAULT_UNIT, type HUUnit } from "@modules/utils/unitType"
import { observable } from "micro-observables"

export type HUTheme = "athlete" | "owner"

export class BrowserProfileService implements Service {
  private _profileTheme = observable<{ theme: HUTheme }>({ theme: "owner" })
  readonly profileTheme = this._profileTheme.readOnly()
  private _profileUnit = observable<{ unit: HUUnit }>({ unit: DEFAULT_UNIT })
  readonly profileUnit = this._profileUnit.readOnly()

  constructor(private localStorage: LocalStorageService) {}

  init() {
    const unsubscribe = this.localStorage.connect(this._profileUnit, LocalStorageKeys.profile.unit, {
      unit: DEFAULT_UNIT,
    })

    return unsubscribe
  }

  setUnit(unit: HUUnit) {
    this._profileUnit.update(() => ({ unit }))
  }
}
